import { SIZES } from 'utils/constants';

export const FILTER_CONFIG = {
  size: { type: 'string', defaultValue: `${SIZES.medium}` },
  gender: { type: 'string', defaultValue: 'woman' },
  cloth_type: { type: 'string', defaultValue: 'upper_body' },
  age: { type: 'string', defaultValue: 'adult' },
};

export const RESULT_PARAMS_CONFIG = {
  views_count: { type: 'number', defaultValue: null },
  model_type: { type: 'string', defaultValue: null },
  video_duration: { type: 'string', defaultValue: null },
  video_model_type: { type: 'string', defaultValue: null },
};

export const IMAGE_PARAM_LIST = [
  {
    title: 'Pose views:',
    input_type: 'radio',
    grup_name: 'views_count',
    variants: [
      {
        filter_name: 'views_count',
        value: 1,
        title: '1',
      },
      { filter_name: 'views_count', value: 3, title: '3' },
      { filter_name: 'views_count', value: 5, title: '5' },
    ],
    button_style: 'light',
  },
  {
    title: 'AI model:',
    input_type: 'radio',
    grup_name: 'model_type',
    variants: [
      {
        filter_name: 'model_type',
        value: 'v1',
        title: 'Mod-y v.1',
      },
      {
        filter_name: 'model_type',
        value: 'v2',
        title: 'Mod-y v.2',
      },
      // {
      //   filter_name: 'model_type',
      //   value: 'beta',
      //   title: 'Mod-y beta',
      // },
    ],
    button_style: 'light',
  },
];

export const VIDEO_PARAM_LIST = [
  {
    title: 'Video duration:',
    input_type: 'radio',
    grup_name: 'video_duration',
    variants: [
      {
        filter_name: 'video_duration',
        value: 7,
        title: '7 sec',
      },
    ],
    button_style: 'light',
  },
  {
    title: 'AI model:',
    input_type: 'radio',
    grup_name: 'video_model_type',
    variants: [
      {
        filter_name: 'video_model_type',
        value: 'v1',
        title: 'Mod-y v.1',
      },
      {
        filter_name: 'video_model_type',
        value: 'v2',
        title: 'Mod-y v.2',
      },
    ],
    button_style: 'light',
  },
];
